import React, { useEffect } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { fetchNonThirdParty } from 'actions/users';
import { fetchAllRoles } from 'actions/utils';
import { BorderWrapper, FlexRow, Title } from 'components/styled-components';
import { InputGroup } from '@blueprintjs/core';
import colors from 'utils/colors';
import { If } from 'utils/functions';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';

const SponsorInfoBase = props => {
  useEffect(() => {
    props.fetchNonThirdParty({ start: 0, limit: -1 });
  }, []);
  const { editing, appUser } = props;
  return (
    <BorderWrapper margin="1rem">
      <Heading>
        <Title>Sponsor Information</Title>
      </Heading>
      <DataWrapper>
        <FlexRow justify="flex-start">
          <div className="medium-text-group" style={{ marginRight: '1rem' }}>
            <MutedLabel>Sponsor Name</MutedLabel>
            <If condition={editing}>
              <Select
                value={props.selectedSponsor}
                getOptionLabel={option =>
                  `${option.firstName} ${option.lastName}`
                }
                getOptionValue={option => option.userID}
                options={props.sponsors}
                name="sponsorInformation"
                onChange={selected =>
                  props.setFieldValue('sponsorInformation', selected)
                }
              />
            </If>
            <If condition={!editing}>
              <div>{`${props.originalSponsor.firstName} ${props.originalSponsor.lastName}`}</div>
            </If>
          </div>
          <div className="medium-text-group">
            <MutedLabel>Email</MutedLabel>
            <If condition={editing}>
              <InputGroup
                value={props.selectedSponsor && props.selectedSponsor.email}
                disabled={true}
              />
            </If>
            <If condition={!editing}>
              <div>{props.originalSponsor.email}</div>
            </If>
          </div>
        </FlexRow>

        {hasPermission(appUser.permissions, permissions.VIEW_DEPARTMENTS) && (
          <div>
            <MutedLabel>Sponsor Department</MutedLabel>
            <If condition={editing}>
              <InputGroup
                value={
                  props.selectedSponsor && props.selectedSponsor.department
                }
                disabled={true}
              />
            </If>
            <If condition={!editing}>
              <div>{props.originalSponsor.department}</div>
            </If>
          </div>
        )}
      </DataWrapper>
    </BorderWrapper>
  );
};

const DataWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  min-height: 12rem;
`;

const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0 0 1rem;
`;

const MutedLabel = styled.span`
  color: ${colors.muted};
  font-size: 0.8rem;
  margin: 1rem 0 0.5rem;
`;

const mapStateToProps = state => ({
  sponsors: state.users.nonThirdPartyUsers,
  loaded: state.users.sponsorsLoaded,
  roles: state.utils.roles,
});

const SponsorInfo = connect(
  mapStateToProps,
  { fetchNonThirdParty, fetchAllRoles }
)(SponsorInfoBase);

export default SponsorInfo;
